import { styled } from '@mui/material';
import { NavLink } from 'react-router-dom';
import MuiButton from '@mui/material/Button';
import { colors } from '../../styles';
import MuiMenu from '@mui/material/Menu';

type ButtonProps = { isScrolled: boolean };

export const Button = styled(MuiButton, {
  shouldForwardProp: (propName) => !['isScrolled'].includes(propName as string),
})<ButtonProps>`
  text-transform: capitalize;

  color: ${({ isScrolled }) => (isScrolled ? colors.mainDark : colors.white)};
  font-size: 18px;
  line-height: 22px;
  padding: 13px 0 13px 0;

  &:hover {
    color: ${({ isScrolled }) => (isScrolled ? ' rgba(34, 34, 34, 0.8)' : colors.blue)};
  }
`;

export const DropdownLink = styled(NavLink)`
  cursor: pointer;
  color: ${colors.mainGray};
  text-decoration: none;
  font-weight: 400;
  line-height: 150%;

  &:hover {
    color: ${colors.mainDark};
  }

  &.active {
    color: ${colors.blue};
  }
`;

export const Menu = styled(MuiMenu)`
  box-shadow: 0 5px 5px -3px rgba(0, 0, 0, 0.2), 0px 8px 10px 1px rgba(0, 0, 0, 0.14),
    0px 3px 14px 2px rgba(0, 0, 0, 0.12);

  ul {
    padding: 0;
  }
`;
